// if (!customElements.get('product-modal')) {
//   customElements.define(
//     'product-modal',
//     class ProductModal extends ModalDialog {
//       constructor() {
//         super();
//       }

//       hide() {
//         super.hide();
//       }

//       show(opener) {
//         super.show(opener);
//         this.showActiveMedia();
//       }

//       showActiveMedia() {
//         this.querySelectorAll(
//           `[data-media-id]:not([data-media-id="${this.openedBy.getAttribute('data-media-id')}"])`
//         ).forEach((element) => {
//           element.classList.remove('active');
//         });
//         const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);
//         const activeMediaTemplate = activeMedia.querySelector('template');
//         const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
//         activeMedia.classList.add('active');
//         activeMedia.scrollIntoView();

//         const container = this.querySelector('[role="document"]');
//         container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

//         if (
//           activeMedia.nodeName == 'DEFERRED-MEDIA' &&
//           activeMediaContent &&
//           activeMediaContent.querySelector('.js-youtube')
//         )
//           activeMedia.loadContent();
//       }
//     }
//   );
// }

if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      showActiveMedia() {
        const isProductPage = window.location.pathname.includes('/products/'); 
        if (isProductPage) {
          this.showActiveMediaWithSwiper();
        } else {
          this.showActiveMediaDefault();
        }
      }

      showActiveMediaWithSwiper() {
        console.log("Using Swiper-based media activation");
      
        const initializeSwiper = () => {
          const mediaId = this.openedBy.getAttribute('data-media-id');
          const mediaElements = Array.from(this.querySelectorAll('[data-media-id]'));
          const activeIndex = mediaElements.findIndex(el => el.getAttribute('data-media-id') === mediaId);
      
          if (this.swiperInstance) {
            console.log(`Sliding to index: ${activeIndex}`);
            this.swiperInstance.slideToLoop(activeIndex !== -1 ? activeIndex : 0);
            return;
          }
      
          this.swiperInstance = new Swiper('.product-media-swiper', {
            loop: true,
            slidesPerView: 1,
            navigation: {
              nextEl: '.modal_btn.swiper-button-next',
              prevEl: '.modal_btn.swiper-button-prev',
            },
            pagination: {
              el: '.swiper-pagination',
              clickable: true,
            },
            zoom: {
              maxRatio: 2,
              minRatio: 1,
              toggle: false, // Disable default double-tap zoom
            },
            on: {
              init: (swiper) => {
                console.log(`Swiper initialized. Sliding to index: ${activeIndex}`);
                setTimeout(() => swiper.slideToLoop(activeIndex !== -1 ? activeIndex : 0), 100);
              },
            },
          });
        };
      
        initializeSwiper();
      
        window.addEventListener('resize', () => {
          if (this.swiperInstance) {
            this.swiperInstance.destroy(true, true);
            this.swiperInstance = null;
          }
          initializeSwiper();
        });
        // Add click event to trigger zoom manually
          document.querySelectorAll('.swiper-slide .swiper-zoom-container').forEach((slide) => {
            slide.addEventListener('click', function () {
              const zoom = this.closest('.product-media-swiper').swiper.zoom;
              if (zoom.scale === 1) {
                zoom.in();
              } else {
                zoom.out();
              }
            });
          });
      }

      showActiveMediaDefault() {
        console.log("Using default media activation");

        this.querySelectorAll(
          `[data-media-id]:not([data-media-id="${this.openedBy.getAttribute('data-media-id')}"])`
        ).forEach((element) => {
          element.classList.remove('active');
        });

        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);
        if (!activeMedia) return;

        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');
        activeMedia.scrollIntoView();

        const container = this.querySelector('[role="document"]');
        if (container) {
          container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;
        }

        if (
          activeMedia.nodeName === 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        ) {
          activeMedia.loadContent();
        }
      }
    }
  );
}